import React from "react";
import "./shared.css";

export default function MetricCard({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  trendLabel = "%",
  color = "primary", // primary, success, warning, danger
}) {
  const isPositive = trend > 0;
  const isNegative = trend < 0;
  const isNeutral = trend === 0;

  return (
    <div className={`metric-card-shared border-left-${color}`}>
      <div className="metric-card-content">
        <span className="metric-card-title">{title}</span>
        <div className="metric-card-value-wrap">
          <span className="metric-card-value">{value}</span>
          {trend !== undefined && (
            <span className={`metric-card-trend ${isPositive ? "trend-up" : isNegative ? "trend-down" : "trend-neutral"}`}>
              {isPositive && "↑"}
              {isNegative && "↓"}
              {isNeutral && "→"}
              {Math.abs(trend)}{trendLabel}
            </span>
          )}
        </div>
        {subtitle && <span className="metric-card-subtitle">{subtitle}</span>}
      </div>
      {Icon && (
        <div className={`metric-card-icon-wrap icon-bg-${color}`}>
          <Icon className={`metric-icon color-${color}`} size={20} />
        </div>
      )}
    </div>
  );
}
